<template>
  <div>
    <div :class="[theme === 1 ? '' : 'theme-2']">
      <notifications group="foo" />
      <div v-if="currentJewelSelection && currentJewelSelection.name && !isSearching">
        <Breadcrumb v-if="!buildYourJewelMode"></Breadcrumb>
        <div v-if="isAma">
          <DetailAma></DetailAma>
          <ring-settings ref="ringSettings" @changeFastDelivery="quantity = 1; setQuantity(1);"
            @changeSettings="resetSwiperIndex()"></ring-settings>
        </div>

        <div class="col d-inline-flex px-0 mt-4 row"
          v-if="!isAma && currentJewelSelection && !!currentJewelSelection.name && !isSearching">
          <div class="col-12 col-md-6 text-left pl-md-0 order-2" :class="[theme === 1 ? 'order-md-1' : '']">
            <div class="col-12">
              <div class="row">
                <div style="z-index: 2" :class="[theme === 1 ? 'col-md-7' : 'p-3']">
                  <div class="row">
                    <p class="jewel-name title mb-0 pl-5 w-100">
                      {{ currentJewelSelection.name }}
                    </p>
                    <p class="text-break w-100 jewel-description pl-5" v-html="jewelDescription"></p>
                  </div>
                  <div class="row" v-if="buildYourJewelMode" v-for="selectedStone of selectedStones">
                    <p class="jewel-name title mb-0 pl-5 w-100">
                      {{ selectedStone.cartItem.name }}
                    </p>
                    <p class="text-break w-100 jewel-description pl-5" v-html="selectedStone.cartItem.description"></p>
                  </div>
                  <ring-settings ref="ringSettings" @changeFastDelivery="
                    quantity = 1;
                  setQuantity(1);
                  " @changeSettings="resetSwiperIndex()"></ring-settings>
                </div>
                <div class="col-md-5 p-0 pr-md-3 pl-md-3 col-right" v-if="theme === 1">
                  <div class="d-none d-md-block" v-if="((imagesAvailable && imagesAvailable.length > 1) || (videos && videos.length > 0)) && jewelDescription
                    ">
                    <div v-swiper:swiperThumbs="swiperThumbsOptions"
                      class="px-1 pt-2 swiper-thumbs swiper-thumbs-desktop">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide" :key="image" v-for="(image, index) in imagesAvailable"
                          :class="{ 'active': index == thumbsActiveIndex }">
                          <!-- v-if="!imgaError" -->
                          <!-- @error="onImageLoadFailure($event)" -->
                          <img :src="baseImageUrl + image" class="border-img" @click="slideSwiperTopTo(index)" />
                        </div>
                        <div class="swiper-slide"
                          :class="{ 'active': imagesAvailable.length + viedoIndex == thumbsActiveIndex }"
                          v-if="videos && videos.length > 0" v-for="(video, viedoIndex) in videos">
                          <img src="../assets/video-icon.png" class="border-img video-icon"
                            @click="slideSwiperTopTo(imagesAvailable.length + viedoIndex)" />
                        </div>
                      </div>
                      <!-- <div class="swiper-pagination"></div> -->
                    </div>
                  </div>
                  <div class="col-price">
                    <div class="ml-md-2 mb-3 mt-3 mt-md-0" v-if="selectedJewel &&
                      selectedJewel.placeholders &&
                      (selectedJewel.placeholders.tctmix ||
                        selectedJewel.placeholders.tctpst) &&
                      (selectedJewel.placeholders.tctmix.replace(/,/, '.') > 0 ||
                        selectedJewel.placeholders.tctpst.replace(/,/, '.') > 0)
                      ">
                      <div class="price-info border-left-0" v-if="!buildYourJewelMode">
                        <div class="label-menu text-uppercase pl-md-2 pl-5">
                          {{ $t("totalCarat") }}
                        </div>
                        <div class="w-100 label-menu text-right pl-2 pr-md-2 pr-5">
                          {{ (selectedJewel.placeholders.tctmix.replace(
                            /,/,
                            "."
                          ) > 0
                            ? selectedJewel.placeholders.tctmix
                            : selectedJewel.placeholders.tctpst) +
                            " " + $t(`ct`)
                          }}

                        </div>
                      </div>
                    </div>
                    <div class="ml-md-2" v-if="!buildYourJewelMode">
                      <div class="price-info border-left-0">
                        <div class="w-100">
                          <p class="
                            text-left
                            mb-0
                            pl-md-2 pl-5
                            text-uppercase
                            label-menu
                          ">
                            {{ $t("quantity") }}
                          </p>
                          <div class="pl-md-2 pl-5 text-left pieces-label" v-if="fastDelivery">
                            <span v-if="selectedJewel.availability == 1">{{ selectedJewel.availability }}
                              {{ $t("pieceAvailable") }}</span>
                            <span v-if="selectedJewel.availability > 1">{{ selectedJewel.availability }}
                              {{ $t("piecesAvailable") }}</span>
                          </div>
                        </div>
                        <div class="w-100 text-right pl-2 pr-md-0 pr-5">
                          <input type="number" class="text-center input-quantity" step="1" min="1" :max="fastDelivery ? selectedJewel.availability : 1000
                            " @change="changeQuantity" v-model="quantity" />
                        </div>
                      </div>
                    </div>

                    <div class="ml-md-2">
                      <div class="price-info jewel-value">
                        <div class="w-100">
                          <div class="
                            text-left
                            pl-md-2 pl-5
                            text-uppercase
                            label-menu
                            price-label
                          ">
                            <span v-if="credential.apiEncryptedUser || !averageOrVatPriceVisible">{{
                              $t("jewelValue")
                            }}</span>
                            <span v-if="!credential.apiEncryptedUser && averageOrVatPriceVisible">{{
                              $t("discountedPrice")
                            }}</span>
                          </div>
                        </div>
                        <div class="w-100 text-right">
                          <div class="price-value pr-md-2 pr-5" v-if="basePrice">
                            {{ priceValue }}€
                          </div>
                        </div>
                      </div>
                      <div class="price-info mb-2">
                        <div class="w-100">
                          <div class="average-price text-left pl-md-2 pl-5" v-if="averageOrVatPriceVisible && credential.apiEncryptedUser
                            ">
                            {{ $t("averagePrice") }}
                          </div>
                          <div class="average-price text-left pl-md-2 pl-5"
                            v-if="!credential.apiEncryptedUser && averageOrVatPriceVisible">{{
                              $t("jewelValue")
                            }}
                          </div>
                        </div>
                        <div class="w-100 text-right pr-md-2 pr-5">
                          <div class="average-price" style="text-decoration: line-through" v-if="averageOrVatPriceVisible
                              ">
                            {{ averageOrVatPriceValue }}
                            €
                          </div>
                        </div>
                      </div>

                      <div class="price-info mb-2" :class="{ 'bg-fastDelivery': fastDelivery }">
                        <div class="
                            text-left
                            pl-md-2 pl-5
                            w-100
                            delivery-label
                          ">
                          {{ $t("plannedShipment") }}
                        </div>
                        <div class="w-100 text-right pl-2 pr-md-2 pr-5">
                          <div class="delivery-label">
                            <span v-if="selectedJewel.shipmentDate">
                              <span v-if="logo || writing">{{
                                selectedJewel.engravingDate
                              }}</span>
                              <span v-else-if="fastDelivery">{{
                                currentJewelSelection.fastDeliveryDate
                              }}</span>
                              <span v-else-if="credential && !credential.apiEncryptedUser">{{
                                selectedJewel.b2cDeliveryDate
                              }}</span>
                              <span v-else>{{ selectedJewel.shipmentDate }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ml-md-2 mb-2" v-if="credential.apiEncryptedUser">
                      <textarea v-model="note" class="item-note" :placeholder="$t('note.placeholder')"></textarea>
                    </div>
                    <div class="ml-md-2">
                      <div class="col-12 px-0">
                        <p v-if="isAmuleto" class="amuleto-warning text-uppercase mb-2">
                          {{ $t("amuletoMinOrderWarning") }}
                        </p>
                        <!-- <button v-if="isAmuleto" id="basketbtn" class="btn text-uppercase rounded-btn w-100" :class="[
                          infoRequestSent
                            ? 'btn-secondary-' + theme
                            : 'btn-primary-' + theme,
                        ]" :disabled="infoRequestSent || infoRequestLoading"
                          v-on:click="requestMoreInfo">
                          <span v-if="infoRequestLoading">...</span>
                          <span v-else-if="infoRequestSent">{{ $t("requestMoreInfoSent") }}</span>
                          <span v-else>{{ $t("requestMoreInfo") }}</span>
                        </button> -->
                        <button id="basketbtn" class="btn text-uppercase rounded-btn w-100" :class="[
                          addedToBasket
                            ? 'btn-secondary-' + theme
                            : 'btn-primary-' + theme,
                        ]" :disabled="!jewelDescription ||
  addedToBasket ||
  quantity < 1 ||
  quantity === '0' ||
  (fastDelivery &&
    quantity > selectedJewel.availability) ||
  ($refs.ringSettings &&
    $refs.ringSettings.incisione &&
    !$refs.ringSettings.incisioneLabel)
  " v-on:click="addToBasket">
                          <span class v-if="addedToBasket">{{
                            $t("addedToBasket")
                          }}</span>
                          <span class v-else>{{ $t("addToBasket") }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-5" v-if="theme === 2">
                  <div class="row">
                    <div class="col-md-7" style="z-index: 1">
                      <div class="row ml-md-2 mb-3" v-if="selectedJewel &&
                        selectedJewel.placeholders &&
                        (selectedJewel.placeholders.tctmix ||
                          selectedJewel.placeholders.tctpst) &&
                        (selectedJewel.placeholders.tctmix.replace(/,/, '.') >
                          0 ||
                          selectedJewel.placeholders.tctpst.replace(/,/, '.') >
                          0)
                        ">
                        <div class="col-12 col-lg-8 p-0">
                          <div class="price-info border-left-0">
                            <div class="w-100 label-menu text-uppercase pl-md-2 pl-5">
                              {{ $t("totalCarat") }}
                            </div>
                            <div class="w-100 label-menu text-right pl-2 pr-md-2 pr-5">
                              {{ (selectedJewel.placeholders.tctmix.replace(
                                /,/,
                                "."
                              ) > 0
                                ? selectedJewel.placeholders.tctmix
                                : selectedJewel.placeholders.tctpst) +
                                " " + $t(`ct`)
                              }}

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row ml-md-2">
                        <div class="col-12 col-lg-8 p-0">
                          <div class="price-info">
                            <div class="w-100 pl-0">
                              <p class="
                                text-left
                                mb-0
                                pl-md-2 pl-5
                                text-uppercase
                                label-menu
                              ">
                                {{ $t("quantity") }}
                              </p>
                            </div>
                            <div class="w-100 pl-0 text-right">
                              <input type="number" class="text-center input-quantity" step="1" min="0"
                                @change="changeQuantity" v-model="quantity" />
                            </div>
                          </div>
                          <br />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="row ml-md-2">
                        <div class="col-12">
                          <div class="price-info row border-left-0" :class="{ 'bg-fastDelivery': fastDelivery }">
                            <div class="col-6 pl-0 d-inline-block position-relative">
                              <div class="
                                text-left
                                pl-md-2 pl-5
                                text-uppercase
                                label-menu
                                avg-price-label
                              ">
                                <span v-if="credential.apiEncryptedUser || !averageOrVatPriceVisible">{{
                                  $t("jewelValue")
                                }}:</span>
                                <span v-if="!credential.apiEncryptedUser && averageOrVatPriceVisible">{{
                                  $t("discountedPrice")
                                }}:</span>
                              </div>
                              <div class="average-price text-left pl-md-2 pl-5" v-if="averageOrVatPriceVisible && credential.apiEncryptedUser
                                  ">
                                {{
                                  $t("averagePrice")
                                }}:
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="float-right price-value" v-if="basePrice">
                                {{ priceValue }}
                                €
                              </div>
                              <div class="average-price float-right" style="text-decoration: line-through" v-if="averageOrVatPriceVisible
                                ">
                                {{ averageOrVatPriceValue }}
                                €
                              </div>
                              <!-- <div
                              class="average-price float-right"
                              v-if="
                                vat &&
                                vat > 1 &&
                                credential &&
                                !credential.apiEncryptedUser
                              "
                            >
                              {{ getAverageOrVatPrice() }}
                              €
                            </div> -->
                            </div>
                          </div>
                          <br />
                        </div>
                      </div>
                      <div class="row ml-md-2">
                        <div class="col-12 px-0">
                          <p v-if="isAmuleto" class="amuleto-warning text-uppercase mb-2">
                            {{ $t("amuletoMinOrderWarning") }}
                          </p>
                          <!-- <button v-if="isAmuleto" id="basketbtn" class="btn text-uppercase rounded-btn w-100" :class="[
                            infoRequestSent
                              ? 'btn-secondary-' + theme
                              : 'btn-primary-' + theme,
                          ]" :disabled="infoRequestSent || infoRequestLoading"
                            v-on:click="requestMoreInfo">
                            <span v-if="infoRequestLoading">...</span>
                            <span v-else-if="infoRequestSent">{{ $t("requestMoreInfoSent") }}</span>
                            <span v-else>{{ $t("requestMoreInfo") }}</span>
                          </button> -->
                          <button id="basketbtn" class="btn text-uppercase rounded-btn w-100" :class="[
                            addedToBasket
                              ? 'btn-secondary-' + theme
                              : 'btn-primary-' + theme,
                          ]" :disabled="!jewelDescription ||
  addedToBasket ||
  quantity < 1 ||
  quantity === '0' ||
  (fastDelivery && quantity > selectedJewel.availability) ||
  ($refs.ringSettings && $refs.ringSettings.incisione && !$refs.ringSettings.incisioneLabel)" v-on:click="addToBasket">
                            <span class v-if="addedToBasket">{{
                              $t("addedToBasket")
                            }}</span>
                            <span class v-else>{{ $t("addToBasket") }}</span>
                          </button>
                          <div class="mt-3 text-right">
                            <span v-if="selectedJewel.shipmentDate" class="delivery-label">{{ $t("plannedShipment") }}
                              <span v-if="logo || writing">{{
                                selectedJewel.engravingDate
                              }}</span>
                              <span v-else-if="fastDelivery">{{
                                currentJewelSelection.fastDeliveryDate
                              }}</span>
                              <span v-else-if="credential && !credential.apiEncryptedUser
                                  ">{{ selectedJewel.b2cDeliveryDate }}</span>
                              <span v-else>{{ selectedJewel.shipmentDate }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 order-1" :class="[theme === 1 ? 'order-md-2' : '']">
            <div class="d-md-none text-left">
              <p class="font-weight-bold w-100 jewel-name mb-0 title-font">
                {{ currentJewelSelection.name }}
              </p>
              <p class="text-break w-100 jewel-description" v-html="jewelDescription"></p>
            </div>
            <p class="text-left sku text-muted mb-1" v-if="selectedSku">
              SKU
              {{
                selectedSku
                ? selectedSku + additionalSkuLabelArray.join("")
                : null
              }}
            </p>
            <p class="text-left sku text-muted mb-1 font-weight-bold" v-if="buildYourJewelMode">
              {{ $t("build_your_jewel.img_warning") }}
            </p>
            <div class="
              text-center
              w-100
              mb-3
              position-relative
              border-img-container
            " :class="{ 'fast-delivery': fastDelivery }" v-if="jewelDescription">

              <div v-swiper:swiperTop="swiperTopOptions" @slideChange="changeSwiperTopIndex"
                class="border-img-current w-100" v-if="imagesAvailable &&
                  imagesAvailable.length > 0 &&
                  jewelDescription
                  ">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" :key="image" v-for="(image, index) in imagesAvailable">
                    <img :src="baseImageUrl + image" class="border-img w-100" />
                  </div>
                  <div class="swiper-slide" v-if="(videos && videos.length > 0)" v-for="video in videos">
                    <video ref="videoRef" class="video-container" id="video-container" width="100%"
                      :src="baseVideoUrl + video" controls allowfullscreen webkitallowfullscreen mozallowfullscreen
                      playsinline></video>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="((imagesAvailable && imagesAvailable.length > 1) || (videos && videos.length > 0)) && jewelDescription
              ">
              <div v-swiper:swiperThumbsMobile="swiperThumbsMobileOptions" class="px-1 pt-2 swiper-thumbs"
                :class="[theme === 1 ? 'd-md-none ' : '']">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" :key="image" v-for="(image, index) in imagesAvailable"
                    :class="{ 'active': index == thumbsActiveIndex }">
                    <!-- v-if="!imgaError" -->
                    <!-- @error="onImageLoadFailure($event)" -->
                    <img :src="baseImageUrl + image" class="border-img w-100 mb-3" @click="slideSwiperTopTo(index)" />
                  </div>
                  <div class="swiper-slide"
                    :class="{ 'active': imagesAvailable.length + videoIndex == thumbsActiveIndex }"
                    v-if="videos && videos.length > 0" v-for="(video, videoIndex) in videos">
                    <img src="../assets/video-icon.png" class="border-img w-100 mb-3 video-icon"
                      @click="slideSwiperTopTo(imagesAvailable.length + videoIndex)" />
                  </div>
                </div>
                <!-- <div class="swiper-pagination"></div> -->
              </div>
            </div>
          </div>

          <div class="col-12 order-3 mt-5">
            <related-jewels></related-jewels>
          </div>
        </div>
      </div>
      <div class="col d-inline-flex px-0 mt-4 row" v-if="isSearching || (currentJewelSelection && !currentJewelSelection.name)
        ">
        <div class="col-12 mb-3 text-center justify-content-center mt-5">
          <DoubleBounce background="#00274F" size="100px"></DoubleBounce>
        </div>
      </div>
    </div>
    <b-modal id="info-request-modal" :title="$t('requestMoreInfo')" ok-only :ok-title="$t('close')" centered modal-class="info-request-modal">
      <p>{{ $t("requestMoreInfoMessage") }}</p>
    </b-modal>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import RingSettings from "./RingSettings";
import RelatedJewels from "./RelatedJewels";
import { directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { DoubleBounce } from "vue-loading-spinner";
import Vue from "vue";
import Breadcrumb from "./Breadcrumb";
import DetailAma from "./ama/DetailAma.vue";
import buildYourJewel from "../api/build-your-jewel";
import detailApi from "../api/detail";

export default {
  name: "Detail",
  components: {
    RingSettings,
    RelatedJewels,
    DoubleBounce,
    Breadcrumb,
    DetailAma
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      imgError: ' "../assets/slider-1.png";',
      quantity: 1,
      imgaError: false,
      retailPerc: 1,
      vat: 1,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
      baseVideoUrl: process.env.VUE_APP_VIDEO_PATH,
      credential: null,
      infoRequestSent: false,
      infoRequestLoading: false,
      swiperTopOptions: {
        slidesPerView: 1,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // Some Swiper option/callback...
      },
      swiperThumbsMobileOptions: {
        slidesPerView: 5,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // Some Swiper option/callback...
      },
      swiperThumbsOptions: {
        slidesPerView: 5,
        spaceBetween: 15,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        direction: 'vertical',
        height: "80px"
      },
      thumbsActiveIndex: 0,
      note: null
    };
  },
  mounted() {
    this.getCategories();
    this.resetAdditionalSkuLabelArray();
    // this.$refs.videoRef.src = this.videos;
    console.log(this);
  },
  created() {
    this.note = null;
    this.resetDetail();
    this.getCred();
    this.retailPerc = this.$store.state.detail.retailPerc;
    this.vat = this.$store.state.detail.vat;
    this.getValueForDetail();
    this.scrollTo(0);
    window.addEventListener("resize", Vue.setHeight);

    // setTimeout(() => {
    // this.getCategories();
    // }, 1000);
  },
  destroyed() {
    this.resetCurrentCategory();
    this.resetCurrentJewel();
    window.removeEventListener("resize", Vue.setHeight);
  },
  watch: {
    "$route.params.sku": function (sku) {
      Vue.setHeight();
      this.scrollTo();
      this.getValueForDetail();
    },
  },
  computed: {
    price: function () {
      if (this.basePrice) {
        return parseFloat(
          (
            (this.basePrice + this.additionalValues) *
            this.vat *
            this.quantity *
            this.retailPerc
          ).toFixed(2)
        );
      } else {
        return 0;
      }
    },
    averageOrVatPrice: function () {
      if (this.vat > 1) {
        return parseFloat(
          (
            (this.avgPrice + this.additionalValues) *
            //PREZZO BARRATO IVA INCLUSA 
            //this.vat *
            this.quantity
          ).toFixed(2)
        );
      } else {
        if (this.avgPrice) {
          return parseFloat(
            (
              (this.avgPrice +
                this.additionalValues -
                (this.fastDelivery
                  ? this.basePrice *
                  this.currentJewelSelection.fastDeliveryMargin -
                  this.basePrice
                  : 0)) *
              this.quantity
            ).toFixed(2)
          );
        } else {
          return 0;
        }
      }
    },
    priceValue: function () {
      return this.price > 0 ? this.price.toLocaleString("it-it", { minimumFractionDigits: 2 }) : "";
    },
    averageOrVatPriceValue: function () {
      return this.averageOrVatPrice > 0
        ? this.averageOrVatPrice.toLocaleString("it-it", { minimumFractionDigits: 2 })
        : "";
    },
    averageOrVatPriceVisible: function () {
      return (
        this.avgPrice &&
        this.credential &&
        (this.credential.apiEncryptedUser || this.pluginSettings.showStrikethroughPrice) &&
        this.retailPerc === 1 &&
        this.averageOrVatPrice > this.price &&
        this.currentJewelSelection.productType != "GOLDSMITH"
      );
    },
    isRhodiumTypeVisible: function () { },
    ...mapState({
      // currentCategory: function () {
      //   setTimeout(() => {
      //     return this.categories.find(
      //       (v) => v.id == this.currentJewelSelection.categoryId
      //     );
      //   }, 400);
      // },
      currentCategory: (state) => {
        return state.detail.currentCategory;
      },
      theme: (state) => state.config.theme,
      searchJewel: (state) => state.list.searchJewel,
      currentJewelSelection: (state) => state.detail.currentJewelSelection,
      categories: (state) => state.list.categories,
      origin: (state) => state.detail.origin,
      selectedSku: (state) => state.detail.selectedSku,
      additionalSkuLabelArray: (state) => state.detail.additionalSkuLabelArray,
      imagesAvailable: (state) => state.detail.imagesAvailable,
      videos: (state) => state.detail.videos,
      additionalValues: (state) => state.detail.additionalValues,
      preselectedJewel: (state) => state.detail.preselectedJewel,
      isSearching: (state) => state.detail.isSearching,
      basePrice: (state) => state.detail.basePrice,
      avgPrice: (state) => state.detail.avgPrice,
      logo: (state) => state.detail.logo,
      writing: (state) => state.detail.writing,
      selectedJewel: (state) => state.detail.selectedJewel,
      jewelDescription: (state) => state.detail.jewelDescription,
      selectedStyle: (state) => state.list.style,
      addedToBasket: (state) => state.detail.addedToBasket,
      fastDelivery: (state) => state.detail.fastDelivery,
      pluginSettings: (state) => state.config.pluginSettings,
      buildYourJewelMode: (state) => state.buildYourJewel.buildYourJewelMode,
      selectedSetting: (state) => state.buildYourJewel.selectedSetting,
      selectedStones: (state) => state.buildYourJewel.selectedStones,
      isAma: (state) => state.config.isAma,
      isPluginB2C: (state) => state.config.isPluginB2C,
      swiper() {
        return this.$refs.mySwiper.$swiper;
      },
    }),
    isAmuleto() {
      return !this.isPluginB2C &&
        this.currentJewelSelection &&
        this.currentJewelSelection.showInfoRequest;
    },
  },
  methods: {
    ...mapMutations("detail", [
      "setValueAndChange",
      "addValuesToSelected",
      "addValueToJewel",
      "setQuantity",
      "setAddedToBasket",
      "resetAdditionalSkuLabelArray",
      "resetCurrentCategory",
      "resetCurrentJewel",
      "resetDetail",
    ]),
    ...mapMutations("list", ["setStyle", "setJewelSearch"]),
    ...mapMutations("detail", ["setPreselectedJewel"]),
    ...mapGetters("config", ["getCredential"]),
    ...mapActions("detail", ["getValues", "getListCategories"]),
    ...mapActions("list", ["getListCategoriesExtra"]),
    getCategories() {
      this.getListCategories("categories");
      if (this.$route.params.direct) {
        this.getListCategoriesExtra("categories");
      }
    },
    onImageLoadFailure() {
      this.imgaError = true;
    },

    // function used to change values in each field
    triggerToChange(value) {
      this.setValueAndChange(value);
    },

    changeQuantity() {
      this.quantity = parseInt(this.quantity);
      this.setQuantity(parseInt(this.quantity));
    },

    getCred() {
      this.credential = this.getCredential();
    },

    setBaseQuantity(qnt) {
      this.quantity = parseInt(qnt);
    },

    getValueForDetail() {
      this.getValues(this.selectedSetting?.sku || this.$route.params.sku);
      if (this.$store.state.detail.quantity)
        this.quantity = parseInt(this.$store.state.detail.quantity);
    },
    scrollTo() {
      window.parent.postMessage(
        {
          func: "setGioielleriaItalianaScroll",
          message: 0,
        },
        "*"
      );
    },

    addToBasket () {
      this.addValuesToSelected({ qnt: parseInt(this.quantity), note: this.note })
      this.$parent.addToBasket()
      this.setAddedToBasket(true)
      if (this.buildYourJewelMode)
        this.$router.push({ name: 'list' })
    },
    requestMoreInfo() {
      this.infoRequestLoading = true;
      detailApi.requestInfo({
        sku: this.selectedSku || this.$route.params.sku,
        productName: this.currentJewelSelection.name,
        note: this.note
      }).then(() => {
        this.infoRequestSent = true;
        this.$bvModal.show('info-request-modal');
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.infoRequestLoading = false;
      });
    },
    resetFilters() {
      this.setJewelSearch({
        label: "goldColorId",
        value: null,
      });
      this.setJewelSearch({
        label: "stoneColor",
        value: null,
      });
      this.setJewelSearch({
        label: "category",
        value: null,
      });
      this.setJewelSearch({
        label: "subCategory",
        value: null,
      });
      this.setJewelSearch({
        label: "minPrice",
        value: null,
      });
      this.setJewelSearch({
        label: "maxPrice",
        value: null,
      });
      this.setJewelSearch({
        label: "text",
        value: null,
      });
      this.setJewelSearch({
        label: "sku",
        value: null,
      });
    },

    goTo(type) {
      this.setStyle(type);
      const root = document.documentElement;
      this.setPreselectedJewel({});
      this.resetFilters();

      this.$router.push({
        name: "list.sublist",
        params: {
          productType: this.currentJewelSelection.productType,
          typeId: this.currentJewelSelection.categoryId,
        },
      });
    },
    changeSwiperTopIndex() {
      this.thumbsActiveIndex = this.swiperTop.activeIndex
      this.swiperThumbs.slideTo(this.swiperTop.activeIndex);
      this.swiperThumbs.updateActiveIndex(this.swiperTop.activeIndex);
      this.swiperThumbsMobile.slideTo(this.swiperTop.activeIndex);
      this.swiperThumbsMobile.updateActiveIndex(this.swiperTop.activeIndex);
    },
    resetSwiperIndex() {
      this.swiperTop && (this.swiperTop.activeIndex = 0);
      this.swiperThumbs && (this.swiperThumbs.activeIndex = 0);
      this.swiperThumbsMobile && (this.swiperThumbs.activeIndex = 0);
      this.swiperTop && (this.thumbsActiveIndex = this.swiperTop.activeIndex);
    },
    slideSwiperTopTo(index) {
      this.swiperTop.slideTo(index);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.border-img {
  box-shadow: 0px 2px 5px 0px #707070;
}

.choice-list {
  font-size: 20px;
}

.border-img-container {
  position: relative;
  width: 100%;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0px 2px 5px 0px #707070;

  &.fast-delivery {
    box-shadow: 0px 2px 5px 5px var(--secondary-color-1);
  }
}

.border-img-current {
  width: 100%;
  // min-height: 570px;
  object-fit: cover;
  // -moz-transform: scale(1.8);
  // -webkit-transform: scale(1.8);
  // transform: scale(1.8);
  max-width: 100%;
}

#basketbtn.btn-primary-1 {
  border-radius: 5px;
  background-color: var(--primary-color-1);
  color: #fff !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  font-size: 16px;
}

#basketbtn.btn-secondary-1 {
  border-radius: 5px;
  color: #fff !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  font-size: 16px;
}

div.rounded-side {
  border-radius: 0 100em 100em 0;
  box-shadow: 0px 1px 4px 0px #707070;
  // height: 40px;
  // line-height: 40px;
}

div.price-info {
  border-bottom: 1px solid var(--secondary-color-1);
  padding: 5px 0px;
  display: flex;

  .label-menu {
    width: 100%;
  }
}

.jewel-value {
  border: 1px solid var(--primary-color-1) !important;
  margin-top: 10px;
}

.average-price {
  font-size: 10px;
  width: 100%;
}

@media only screen and (min-width: 768px) {
  .opt-top {
    margin-top: -200px;
  }

  .average-price {
    font-size: 12px;
    width: 100%;
  }

  .delivery-label {
    font-size: 12px !important;
  }
}

.bg-or {
  background-color: var(--primary-color-1) !important;
  color: var(--primary-color-1);
  // width: 20%;
  cursor: pointer;
}

.bg-fastDelivery {
  background-color: var(--secondary-color-1);
}

.bg-gi {
  background-color: var(--primary-color-1);
  color: #fff;

  // width: 20%;
  cursor: pointer;
}

.bg-no-sel {
  background-color: var(--non-selected-color-bg-1);
  color: var(--non-selected-color-label-1);
  // width: 15%;
  cursor: pointer;
}

.jewel-name {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: 1px solid var(--secondary-color-1);
}

.jewel-description {
  color: var(--gray-label-1);
  font-size: 14px;
  padding-top: 10px;
}

.path-list {
  font-family: var(--font-family);
  font-size: 20px;
  color: var(--secondary-color-1);
}

.title-font {
  font-family: var(--secondary-font-family);
  font-size: 18px;
  font-weight: 500;
}

.input-quantity {
  border: 1px solid var(--primary-color-1);
  border-radius: 7px;
  line-height: 25px;
  width: inherit;
}

.delivery-label {
  font-weight: 300;
  font-size: 10px;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.pieces-label {
  font-weight: 300;
  font-size: 12px;
  color: red;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.price-value {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-family: var(--secondary-font-family);
  font-size: 20px;
  font-weight: 500;
  width: 100%;
}

.avg-price-label {
  font-weight: 500;
}

.label-menu {
  font-size: 18px;
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .label-menu {
    font-size: 12px;
  }

  .rounded-btn {
    font-size: 12px;
  }

  .jewel-name,
  .jewel-description {
    font-size: 12px;
  }

  .sku {
    font-size: 14px;
  }

  #basketbtn.btn-primary-1 {
    border-radius: 5px;
    background-color: var(--primary-color-1);
    color: #fff !important;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    font-size: 12px;
  }

  #basketbtn.btn-secondary-1 {
    border-radius: 5px;
    color: #fff !important;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    font-size: 12px;
  }

  .choice-list {
    font-size: 16px;
  }

  .price-value {
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    font-family: var(--secondary-font-family);
    font-size: 12px;
    font-weight: 500;
    width: 100%;
  }

  .swiper-thumbs-desktop {
    .swiper-slide {
      .border-img {
        height: 60px !important;
      }
    }
  }
}

@media only screen and (max-width: 768px) {

  .rounded-btn {
    font-size: 12px;
  }

  .jewel-name,
  .jewel-description {
    font-size: 14px;
  }

  .sku {
    font-size: 14px;
  }

  .price-value {
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    font-family: var(--secondary-font-family);
    font-size: 14px;
    font-weight: 500;
    width: 100%;
  }

  .label-menu {
    font-size: 12px;
  }

  .rounded-btn {
    font-size: 12px;
  }

  .choice-list {
    font-size: 16px;
  }
}

/*
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}*/
.optional-img {
  -moz-transform: scale(0.6);
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}

.col-price {
  margin-top: auto;
}

.col-right {
  display: flex;
  flex-direction: column;
}

.theme-2 {

  span,
  div,
  p {
    color: var(--primary-color-1);
  }

  .input-incisione {
    border: 1px solid var(--primary-color-1) !important;
  }

  .input-quantity {
    border: 1px solid var(--primary-color-1);
  }

  .select-setting {
    border: 1px solid var(--primary-color-1) !important;
  }

  .btn-primary-2 {
    border-radius: 5px;
    background-color: var(--primary-color-1);
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    font-size: 12px;

    span {
      color: var(--gray-label-1) !important;
    }
  }

  .btn-secondary-2 {
    border-radius: 5px;
    background-color: var(--primary-color-1);
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    font-size: 12px;

    span {
      color: var(--gray-label-1) !important;
    }
  }
}

.swiper-thumbs {
  .swiper-slide {
    opacity: 0.5;

    &.active {
      opacity: 1;
    }
  }
}

.swiper-thumbs-desktop {
  text-align: right;
  margin-right: -15px;
  margin-top: 20px;

  .swiper-slide {
    .border-img {
      height: 100px;
    }

    .video-icon {
      padding: 25px;
    }
  }
}

.video-container {
  display: block;
  height: 100%;
}

.video-icon {
  padding: 30%;
}

.item-note {
  width: 100%;
  font-size: 14px;
  padding: 4px;
}

::v-deep .info-request-modal .modal-footer .btn-primary {
  background-color: var(--primary-color-1) !important;
  border-color: var(--primary-color-1) !important;
  color: #fff !important;
  border-radius: 5px;
}

.amuleto-warning {
  color: #c0392b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
}

</style>
